import { render, staticRenderFns } from "./SupplierBrowse.vue?vue&type=template&id=065cc6d0"
import script from "./SupplierBrowse.vue?vue&type=script&lang=js"
export * from "./SupplierBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports